import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize32 {
  size: '32';
}
interface OverrideIconSize40 {
  size: '40';
}
type OverrideIconSize = OverrideIconSize32 | OverrideIconSize40;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '32') {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM6.66667 12.9083H8.22378V16.7926C8.22378 17.3515 8.37065 17.8007 8.66439 18.1401C8.95813 18.4794 9.35596 18.6491 9.85789 18.6491C10.3598 18.6491 10.7576 18.4794 11.0514 18.1401C11.3451 17.8007 11.492 17.3515 11.492 16.7926V12.9083H13.0491V16.7926C13.0491 17.4428 12.9165 18.0146 12.6513 18.5079C12.3861 19.0013 12.0125 19.382 11.5305 19.6501C11.0485 19.9182 10.491 20.0522 9.85789 20.0522C9.22477 20.0522 8.66724 19.9182 8.18528 19.6501C7.70331 19.382 7.32972 19.0013 7.0645 18.5079C6.79928 18.0146 6.66667 17.4428 6.66667 16.7926V12.9083ZM18.345 19.8811L16.9932 17.6823H15.7527V19.8811H14.1956V12.9083H17.0018C17.5836 12.9083 18.0855 13.0067 18.5076 13.2035C18.9296 13.4003 19.2519 13.6783 19.4743 14.0377C19.6968 14.397 19.808 14.8162 19.808 15.2953C19.808 15.7744 19.6982 16.1922 19.4786 16.5487C19.259 16.9052 18.9439 17.1804 18.5332 17.3743L20.1502 19.8811H18.345ZM16.9333 16.3049H15.7527V14.2858H16.9333C17.3497 14.2858 17.6734 14.3728 17.9044 14.5467C18.1354 14.7207 18.2509 14.9702 18.2509 15.2953C18.2509 15.6204 18.1354 15.87 17.9044 16.0439C17.6734 16.2179 17.3497 16.3049 16.9333 16.3049ZM22.426 12.9083V18.5037H25.9081V19.8811H20.8689V12.9083H22.426Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '40') {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM8.33328 16.1354H10.2797V20.9907C10.2797 21.6894 10.4633 22.2509 10.8304 22.6751C11.1976 23.0993 11.6949 23.3114 12.3223 23.3114C12.9497 23.3114 13.447 23.0993 13.8142 22.6751C14.1814 22.2509 14.3649 21.6894 14.3649 20.9907V16.1354H16.3113V20.9907C16.3113 21.8035 16.1456 22.5182 15.814 23.1349C15.4825 23.7516 15.0155 24.2275 14.4131 24.5626C13.8106 24.8977 13.1137 25.0653 12.3223 25.0653C11.5309 25.0653 10.834 24.8977 10.2315 24.5626C9.62909 24.2275 9.1621 23.7516 8.83057 23.1349C8.49904 22.5182 8.33328 21.8035 8.33328 20.9907V16.1354ZM22.9313 24.8514L21.2416 22.1029H19.6909V24.8514H17.7445V16.1354H21.2523C21.9795 16.1354 22.6069 16.2584 23.1345 16.5044C23.6621 16.7503 24.0649 17.0979 24.3429 17.5471C24.621 17.9963 24.76 18.5203 24.76 19.1192C24.76 19.7181 24.6228 20.2403 24.3483 20.6859C24.0738 21.1315 23.6799 21.4755 23.1666 21.7179L25.1878 24.8514H22.9313ZM21.1667 20.3811H19.6909V17.8572H21.1667C21.6872 17.8572 22.0918 17.9659 22.3805 18.1834C22.6693 18.4009 22.8137 18.7128 22.8137 19.1192C22.8137 19.5256 22.6693 19.8375 22.3805 20.0549C22.0918 20.2724 21.6872 20.3811 21.1667 20.3811ZM28.0325 16.1354V23.1296H32.3852V24.8514H26.0862V16.1354H28.0325Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 32, 40 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'url');
export default IconComponent;
